import enterprise from "../../layout/enterprise"

// 注意路由格式前缀一定要加/webenterprise
export default {
    path: "/",
    component: enterprise,
    redirect: "/webenterprise/homePage",
    alwaysShow: true,
    name: "webenterprise",
    children: [
        {
            path: "/webenterprise/homePage",
            name: "homePage",
            meta: {
                module: "enterprise",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:0
            },
            component: () => import("@/webenterprise/homePage/index")  
        },
        {
            path: "/webenterprise/bannerDetail",
            name: "bannerDetail",
            meta: {
                module: "enterprise",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                index:0
            },
            component: () => import("@/webenterprise/homePage/bannerDetail")  
        },
        {
            path: "/webenterprise/cooperate",
            name: "cooperate",
            meta: {
                module: "enterprise",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:3
            },
            component: () => import("@/webenterprise/homePage/cooperate")  
        },
        {
            path: "/webenterprise/newsInfo",
            name: "newsInfo",
            meta: {
                module: "enterprise",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:4
            },
            component: () => import("@/webenterprise/homePage/newsInfo")  
        },
        {
            path: "/webenterprise/enhelpList",
            name: "enhelpList",
            meta: {
                module: "enterprise",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:5
            },
            component: () => import("@/webenterprise/enhelpList/index")
        },
        {
            path: "/webenterprise/login",
            name: "enLogin",
            meta: {
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				}
            },
            component: () => import("@/webenterprise/auth/login")   
        },
        {
            path: "/webenterprise/enhelpdetail",
            name: "enhelpdetail",
            meta: {
                module: "enterprise",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				}
            },
            component: () => import("@/webenterprise/enhelpdetail/index")
        },
        {
            path: "/webenterprise/endowloadDetail",
            name: "endowloadDetail",
            meta: {
                module: "endowloadDetail",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:1
            },
            component: () => import("@/webenterprise/endowloadDetail/index")
        },
        {
            path: "/webenterprise/enCert",
            name: "enCert",
            meta: {
                module: "enCert",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:7
            },
            component: () => import("@/webenterprise/enCert/index")
        }, {
            path: "/webenterprise/mobileIndex",
            name: "mobileIndex",
            meta: {
                module: "enCert",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:1
            },
            component: () => import("@/webenterprise/enCert/mobileIndex")
        },
        {
            path: "/webenterprise/searchCert",
            name: "searchCert",
            meta: {
                module: "enCert",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:7
            },
            component: () => import("@/webenterprise/enCert/searchCert")
        },
        {
            path: "/webenterprise/enTouch",
            name: "enTouch",
            meta: {
                module: "enTouch",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:1
            },
            component: () => import("@/webenterprise/enTouch/index")
        },
        {
            path: "/webenterprise/enTouch1",
            name: "enTouch1",
            meta: {
                module: "enTouch1",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:1
            },
            component: () => import("@/webenterprise/enTouch/index1")
        },
        {
            path: "/webenterprise/enTouchDetail",
            name: "enTouchDetail",
            meta: {
                module: "enTouch",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:1
            },
            component: () => import("@/webenterprise/enTouch/enTouchDetail")
        },
        {
            path: "/webenterprise/creatOrder",
            name: "creatOrder",
            meta: {
                module: "endowloadDetail",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
            },
            component: () => import("@/webenterprise/endowloadDetail/creatOrder/index")
        },
        {
            path: "/webenterprise/buyOrder",
            name: "buyOrder",
            meta: {
                module: "endowloadDetail",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				}
            },
            component: () => import("@/webenterprise/endowloadDetail/buyOrder/index")
        },{
            path: "/webenterprise/viewpay",
            name: "viewpay",
            meta: {
                module: "endowloadDetail",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				}
            },
            component: () => import("@/webenterprise/endowloadDetail/buyOrder/viewpay")
        },
        {
            path: "/webenterprise/enSolution",
            name: "enSolution",
            meta: {
                module: "endowloadDetail",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                index:2
            },
            component: () => import("@/webenterprise/enSolution/index")
        },
        {
            path: "/webenterprise/enNewsDetail",
            name: "enNewsDetail",
            meta: {
                module: "endowloadDetail",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				}
            },
            component: () => import("@/webenterprise/enNewsDetail/index")
        },{
            path: "/webenterprise/enCaseDetail",
            name: "enCaseDetail",
            meta: {
                module: "cooperate",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
            },
            component: () => import("@/webenterprise/enCaseDetail/index")
        },
        {
            path: "/webenterprise/enAbout",
            name: "enAbout",
            meta: {
                module: "enAbout",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:6
            },
            component: () => import("@/webenterprise/enAbout/Publicindex")
        }, 
        {
            path: "/webenterprise/jobHunting",
            name: "jobHunting",
            meta: {
                module: "enAbout",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:6
            },
            component: () => import("@/webenterprise/enAbout/jobHunting/index")
        }, {
            path: "/webenterprise/jobDetail",
            name: "jobDetail",
            meta: {
                module: "enAbout",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                index:6
            },
            component: () => import("@/webenterprise/enAbout/jobHunting/jobDetail")
        },{
            path: "/webenterprise/enSetting",
            name: "enSetting",
            meta: {
                module: "enSetting",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                
            },
            component: () => import("@/webenterprise/enSetting/index")
        },{
            path: "/webenterprise/enBusiness",
            name: "enBusiness",
            meta: {
                module: "enBusiness",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                
            },
            component: () => import("@/webenterprise/enBusiness/index")
        },{
            path: "/webenterprise/inviteAccount",
            name: "inviteAccount",
            meta: {
                module: "enterprise",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                
            },
            component: () => import("@/webenterprise/inviteAccount/index")
        },
        {
            path: "/webenterprise/adminMobileTransfer",
            name: "adminMobileTransfer",
            meta: {
                module: "enterprise",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                
            },
            component: () => import("@/webenterpriseManage/publicViews/adminMobileTransfer")
        },
        {
            path: "/webenterprise/mobileCenter",
            name: "mobileCenter",
            meta: {
                module: "enterprise",
                backgroundColor: "#fff",
				mainCss:{
					width: "100%"
				},
                keepAlive:false,
                
            },
            component: () => import("@/webenterpriseManage/publicViews/mobileCenter")
        }
    ]
}